/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState } from "react";
import "./db.scss";
import { Container, Row, Col } from "react-bootstrap";
import Sidebar from "./Sidebar/Sidebar";
import { LogoutModal } from "./Db/Modals/LogoutModal";
import { Route, withRouter, useHistory, Link } from "react-router-dom";
import Profile from "./Db/Profile/Profile";
import Facilities from "./Db/Facilities/Facilities";
import Financials from "./Db/Financials/Financials";
import { Services } from "./Db/Sevices/Services";
import { ServicesOpen } from "./Db/Explore/services/ServicesOpen";
import NewFacility from "./Db/Facilities/NewFacility";
import NewDoctor from "./Db/Explore/addDoctor";
import ChangePassword from "./Db/ChangePassword/ChangePassword";
import BankDetails from "./Db/BankDetails/BankDetails";
import BankLayout from "./Db/BankDetails/BankLayout";
import { getSession } from "../redux/actions/authActions";
import ExploreLayout from "./Db/Explore/ExploreLayout";
import OrderLayout from "./Db/Order/AddOrder/OrderLayout";
import Patient from "./Db/Patient/Patient";
import PatientProfileForm from "./Db/Explore/PatientProfile/PatientProfileForm";
import Order from "./Db/Order/Order";
import { OrderServicesOpen } from "./Db/Order/AddOrder/services/ServicesOpen";
import NewOrder from "./Db/Order/NewOrder";
import Fees from "./Db/Fees/Fees";
import Users from "./Db/Users/Users";
import Suggestion from "./Db/Suggestion/Suggestion";
import Payout from "./Db/Payout/Payout";
import PayoutFiles from "./Db/Payout/PayoutFiles";
import Layout from "./Layout";
import ChatLayout from "./Db/Messages/ChatLayout";
import { ProfileListexplore } from "./Db/Explore/PatientProfile/ProfileListexplore";
import { ProfileListOrder } from "./Db/Order/AddOrder/PatientProfile/ProfileListOrder";
import { navlinks } from "./constant";
import { useEffect } from "react";
import { Icon } from "@iconify/react";
import { imageUrls } from "../constants/images";
import CartList from "./Db/Cart/CartList";
import Wallet from "./Db/Wallet";
import MainDashboard from "./Db/MainDashboard/MainDashboard";
import { useDispatch, useSelector } from "react-redux";
import {
  getProfile,
  getProfileSession,
} from "../redux/actions/dbactions/profileActions";
import {
  addToCart,
  getCartItems,
  updateCart,
} from "../redux/actions/dbactions/cartActions";
import CartIconBlack from "../../assets/CartIconBlack";
import { toast } from "react-toastify";
import MapView from "../MapView";
import { TransactionHistory } from "./Db/Wallet/TransactionHistory";
import { ManageSubscriptions } from "./Db/Wallet/ManageSubscriptions";
import { UserWalletDetails } from "./Db/Wallet/UserWalletDetails";
import {
  getAllSubscriptions,
  getRecentTransactions,
  getRecurringTypes,
} from "../redux/actions/dbactions/walletActions";
import TransactionsWrapper from "./Db/Transactions/Wrapper";

const DashboardLayout = () => {
  const history = useHistory();
  const cartItems = useSelector((state) => state?.cart?.cartItems);
  const facilityId =
    (cartItems && cartItems?.[0]?.svcsc_cart_jsn?.order_svcf_id) || null;
  const dispatch = useDispatch();
  const [searchQuery, setSearchQuery] = useState("");
  const [mobile, setMobile] = useState(false);
  const [show, setShow] = useState(false);
  const [navigationLinks, setNavigationLinks] = useState([]);
  const { role_id, user_profile_id } = getSession();
  const { profileData } = getProfileSession();

  let orderPatient = JSON.parse(localStorage.getItem("newPatient"));

  const roleID = role_id;
  const hideMobile = () => {
    setMobile(!mobile);
  };

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleCart = (value, cartData = []) => {
    const previousData =
      cartData?.[0]?.svcsc_cart_jsn?.service_order_line || [];
    const data = {
      user_profile_id,
      sys_active_yn: "Y",
      sys_user_id: user_profile_id,
      svcsc_cart_jsn: {
        ord_svc_date: value[value.length - 1]?.ord_svc_date,
        ord_svc_time: value[value.length - 1]?.ord_svc_time,
        order_dte_tsp: new Date().toISOString(),
        order_svcf_id: value[value.length - 1]?.svcf_id,
        user_profile_id: user_profile_id,
        order_svc_user_id: orderPatient?.svcuser_profile_id,
        order_ship_to_id: 2,
        order_ship_instructions: "Ring the bell upon arrival",
        order_bill_to_id: 2,
        order_status_id: 1,
        sys_user_id: user_profile_id,
        role_id: profileData?.role_id,
        sys_source_ip: "192.168.2.2",
        sys_crte_tsp: profileData?.sys_crte_tsp,
        sys_last_updte_tsp: profileData?.sys_updte_tsp,
        sys_ord_active_yn: "Y",
        service_order_line: [
          ...previousData,
          ...JSON.parse(JSON.stringify(value)),
        ],
      },
    };

    if (cartData?.length > 0) {
      dispatch(updateCart(data)).then(() => {
        dispatch(getCartItems());
        localStorage.removeItem("cartData");
      });
    } else {
      dispatch(addToCart(data)).then(() => {
        dispatch(getCartItems());
        localStorage.removeItem("cartData");
      });
    }
  };

  useEffect(() => {
    dispatch(getProfile());
  }, [history.location.pathname]);

  useEffect(() => {
    const fetchNavigationLinks = () => {
      const role = navlinks.roles.find((role) => role.role === roleID);
      if (role) {
        setNavigationLinks(role.navigationLinks);
      } else {
        setNavigationLinks([]);
      }
    };

    fetchNavigationLinks();
    dispatch(getCartItems()).then((data) => {
      if (localStorage.getItem("cartData")) {
        const cartData = JSON.parse(localStorage.getItem("cartData"));
        handleCart(cartData, data);
      }
    });

    dispatch(getAllSubscriptions());
    dispatch(getRecurringTypes());
    dispatch(getRecentTransactions());
  }, [roleID]);

  const handleNavLinkClick = (e, url) => {
    if (
      profileData.user_has_profile_yn !== "Y" &&
      url !== "/dashboard/profile"
    ) {
      e.preventDefault();
      toast.dismiss();
      toast.error("Please fill your profile first to access other pages");
    } else {
      history.push(url);
    }
  };

  const total =
    cartItems?.length > 0 &&
    cartItems[0]?.svcsc_cart_jsn?.service_order_line
      ?.reduce((sum, item) => sum + Number(item?.svc_price_amt), 0)
      .toFixed(2);

  return (
    <Layout>
      <div className={`dblayout`}>
        <div className="desktop_dev">
          <Sidebar
            handleShow={handleShow}
            setShow={() => setShow(true)}
            show={show}
            mobile={mobile}
            setMobile={setMobile}
            searchQuery={searchQuery}
            setSearchQuery={setSearchQuery}
            navigationLinks={navigationLinks}
          />
        </div>

        <div className="mobile_dev">
          <Sidebar
            handleShow={handleShow}
            hideMobile={hideMobile}
            setShow={() => setShow(true)}
            searchQuery={searchQuery}
            show={show}
            mobile={mobile}
            setMobile={setMobile}
            setSearchQuery={setSearchQuery}
            navigationLinks={navigationLinks}
          />
        </div>
        <div
          className={` side_wrapper !ml-0 tab:!ml-[261px] bg-[#FAFAFB] relative mrleft`}
        >
          <div className="bg-white mainDiv sticky top-0 z-50">
            <Container fluid>
              <div className="flex justify-between items-center flex-nowrap">
                <div className="logo sm:hidden">
                  <Link to={"/dashboard"}>
                    <div className="w-40">
                      <img src={imageUrls.logo} alt="logo" />
                    </div>
                  </Link>
                </div>

                <div className="flex gap-3">
                  <button
                    className="relative sm:hidden"
                    onClick={(e) => {
                      handleNavLinkClick(
                        e,
                        `/dashboard/cart/${facilityId}?patient=null`
                      );
                    }}
                  >
                    {total && (
                      <span className="border border-black bg-white px-2 absolute left-1/2 bottom-0.5 transform -translate-x-1/2 translate-y-full !text-black mx-auto h-4 inline-flex rounded-full items-center justify-center text-xs">
                        ${total}
                      </span>
                    )}

                    <CartIconBlack className="size-8" />
                    <span className="absolute -right-1 -top-1 bg-[#132573] size-5 inline-flex rounded-full items-center justify-center text-white text-xs">
                      {(cartItems &&
                        cartItems?.[0]?.svcsc_cart_jsn?.service_order_line
                          ?.length) ||
                        0}
                    </span>
                  </button>
                  <button
                    className="relative flex items-center gap-0 sm:hidden"
                    onClick={(e) => {
                      handleNavLinkClick(e, `/dashboard/wallet`);
                    }}
                  >
                    <span className="text-gray-900 font-semibold text-sm2">
                      ${profileData.wallet_balance || "0.00"}
                    </span>
                  </button>
                  <div className="hamburger mobile_dev sm:fixed left-8 top-5 z-50 !flex items-center">
                    <Icon
                      icon="quill:hamburger-sidebar"
                      className="w-[30px] h-[30px] cursor-pointer"
                      onClick={() => setMobile(!mobile)}
                    />
                  </div>
                </div>
              </div>
            </Container>
          </div>

          <Container fluid>
            <Row className="bg-[#FAFAFB]">
              <Col className="p-0">
                {roleID === "5" && (
                  <>
                    <Route
                      exact
                      path="/dashboard/mainDashboard"
                      component={MainDashboard}
                    />
                    <Route
                      exact
                      path="/dashboard/profile/"
                      component={Profile}
                    />
                    <Route
                      exact
                      path="/dashboard/"
                      render={(props) => (
                        <ExploreLayout
                          {...props}
                          cartItems={
                            cartItems?.[0]?.svcsc_cart_jsn
                              ?.service_order_line || []
                          }
                          handleCartItems={handleCart}
                        />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/map"
                      render={(props) => (
                        <MapView
                          {...props}
                          isLogged={true}
                          cartItems={
                            cartItems?.[0]?.svcsc_cart_jsn
                              ?.service_order_line || []
                          }
                          handleCartItems={handleCart}
                        />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/patient"
                      render={(props) => (
                        <Patient {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/order"
                      render={(props) => (
                        <Order {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/transactions"
                      render={(props) => (
                        <TransactionsWrapper
                          {...props}
                          searchQuery={searchQuery}
                        />
                      )}
                    />
                    <Route path={`/dashboard/new-order`} component={NewOrder} />
                    <Route
                      exact
                      path="/dashboard/addorder/orderlayout"
                      component={OrderLayout}
                    />
                    <Route
                      exact
                      path={`/dashboard/explore/services/:facilityId`}
                      component={ServicesOpen}
                    />
                    <Route
                      exact
                      path={`/dashboard/order/addorder/services/:facilityId`}
                      component={OrderServicesOpen}
                    />
                    <Route
                      path={`/dashboard/explore/:serviceID/patient-profiles`}
                      component={ProfileListexplore}
                    />
                    <Route
                      path={`/dashboard/explore/add-patient`}
                      component={PatientProfileForm}
                    />
                    <Route
                      path={`/dashboard/order/addorder/:serviceID/patient-profiles`}
                      component={ProfileListOrder}
                    />
                    <Route
                      exact
                      path={`/dashboard/messages`}
                      component={ChatLayout}
                    />
                    <Route
                      path={`/dashboard/change-password`}
                      component={ChangePassword}
                    />
                    <Route
                      exact
                      path={`/dashboard/cart/:facilityId`}
                      component={CartList}
                    />
                    <Route
                      exact
                      path={`/dashboard/wallet`}
                      component={Wallet}
                    />
                    <Route
                      exact
                      path={`/dashboard/wallet/transactions`}
                      render={(props) => (
                        <TransactionHistory {...props} showAll />
                      )}
                    />{" "}
                    <Route
                      exact
                      path={`/dashboard/wallet/subscriptions`}
                      render={(props) => (
                        <ManageSubscriptions {...props} showAll />
                      )}
                    />
                  </>
                )}
                {roleID === "4" && (
                  <>
                    <Route
                      exact
                      path={`/dashboard/`}
                      render={(props) => (
                        <Facilities {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/facilities"
                      render={(props) => (
                        <Facilities {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      path={`/dashboard/new-facility`}
                      component={NewFacility}
                    />
                    <Route
                      path={`/dashboard/new-doctor`}
                      component={NewDoctor}
                    />
                    <Route
                      path={`/dashboard/services/:facilityId`}
                      component={Services}
                    />
                    {/* <Route     --Cosmas
                    path={`/dashboard/services`}
                    component={Services}
                  /> */}

                    <Route
                      exact
                      path="/dashboard/profile/"
                      component={Profile}
                    />
                    <Route
                      exact
                      path={`/dashboard/bank-details`}
                      render={(props) => (
                        <BankLayout {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      path={`/dashboard/new-bank`}
                      component={BankDetails}
                    />

                    <Route
                      exact
                      path={`/dashboard/messages`}
                      component={ChatLayout}
                    />

                    <Route
                      path={`/dashboard/financials`}
                      component={Financials}
                    />
                    <Route
                      path={`/dashboard/change-password`}
                      component={ChangePassword}
                    />

                    <Route
                      exact
                      path="/dashboard/patient"
                      render={(props) => (
                        <Patient {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/order"
                      render={(props) => (
                        <Order {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/transactions"
                      render={(props) => (
                        <TransactionsWrapper
                          {...props}
                          searchQuery={searchQuery}
                        />
                      )}
                    />
                    <Route path={`/dashboard/new-order`} component={NewOrder} />

                    <Route
                      exact
                      path="/dashboard/addorder/orderlayout"
                      component={OrderLayout}
                    />
                    <Route
                      exact
                      path={`/dashboard/explore/services/:facilityId`}
                      component={ServicesOpen}
                    />
                    <Route
                      exact
                      path={`/dashboard/order/addorder/services/:facilityId`}
                      component={OrderServicesOpen}
                    />

                    <Route
                      path={`/dashboard/explore/:serviceID/patient-profiles`}
                      component={ProfileListexplore}
                    />
                    <Route
                      path={`/dashboard/order/addorder/:serviceID/patient-profiles`}
                      component={ProfileListOrder}
                    />
                  </>
                )}
                {roleID === "3" && (
                  <>
                    <Route
                      exact
                      path="/dashboard/fees"
                      render={(props) => (
                        <Fees {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/users"
                      render={(props) => (
                        <Users {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/facilities"
                      render={(props) => (
                        <Facilities {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      path={`/dashboard/new-facility`}
                      component={NewFacility}
                    />
                    <Route
                      path={`/dashboard/new-doctor`}
                      component={NewDoctor}
                    />
                    <Route
                      path={`/dashboard/services/:facilityId`}
                      component={Services}
                    />
                    <Route
                      exact
                      path={`/dashboard/messages`}
                      component={ChatLayout}
                    />
                    <Route
                      path={`/dashboard/bank-details`}
                      component={BankLayout}
                    />
                    <Route
                      exact
                      path="/dashboard/profile"
                      component={Profile}
                    />
                    <Route
                      path={`/dashboard/change-password`}
                      component={ChangePassword}
                    />
                    <Route
                      exact
                      path="/dashboard/"
                      render={(props) => (
                        <ExploreLayout
                          {...props}
                          cartItems={
                            cartItems?.[0]?.svcsc_cart_jsn
                              ?.service_order_line || []
                          }
                          handleCartItems={handleCart}
                        />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/map"
                      render={(props) => (
                        <MapView
                          {...props}
                          isLogged={true}
                          cartItems={
                            cartItems?.[0]?.svcsc_cart_jsn
                              ?.service_order_line || []
                          }
                          handleCartItems={handleCart}
                        />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/patient"
                      render={(props) => (
                        <Patient {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/order"
                      render={(props) => (
                        <Order {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/transactions"
                      render={(props) => (
                        <TransactionsWrapper
                          {...props}
                          searchQuery={searchQuery}
                        />
                      )}
                    />
                    <Route path={`/dashboard/new-order`} component={NewOrder} />
                    <Route
                      exact
                      path="/dashboard/addorder/orderlayout"
                      component={OrderLayout}
                    />
                    <Route
                      exact
                      path={`/dashboard/explore/services/:facilityId`}
                      component={ServicesOpen}
                    />
                    <Route
                      exact
                      path={`/dashboard/order/addorder/services/:facilityId`}
                      component={OrderServicesOpen}
                    />
                    <Route
                      path={`/dashboard/explore/:serviceID/patient-profiles`}
                      component={ProfileListexplore}
                    />
                    <Route
                      path={`/dashboard/explore/add-patient`}
                      component={PatientProfileForm}
                    />
                    <Route
                      path={`/dashboard/order/addorder/:serviceID/patient-profiles`}
                      component={ProfileListOrder}
                    />
                    <Route
                      exact
                      path={`/dashboard/cart/:facilityId`}
                      component={CartList}
                    />
                    <Route
                      exact
                      path={`/dashboard/wallet`}
                      component={Wallet}
                    />
                    <Route
                      exact
                      path={`/dashboard/wallet/transactions`}
                      render={(props) => (
                        <TransactionHistory {...props} showAll />
                      )}
                    />{" "}
                    <Route
                      exact
                      path={`/dashboard/wallet/subscriptions`}
                      render={(props) => (
                        <ManageSubscriptions {...props} showAll />
                      )}
                    />
                  </>
                )}
                {roleID === "1" && (
                  <>
                    <Route
                      exact
                      path="/dashboard/"
                      render={(props) => (
                        <Facilities {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/users"
                      render={(props) => (
                        <Users {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      path={`/dashboard/new-facility`}
                      component={NewFacility}
                    />
                    <Route
                      exact
                      path={`/dashboard/messages`}
                      component={ChatLayout}
                    />
                    <Route
                      path={`/dashboard/services/:facilityId`}
                      component={Services}
                    />
                    <Route
                      exact
                      path="/dashboard/profile/"
                      component={Profile}
                    />
                    <Route
                      path={`/dashboard/change-password`}
                      component={ChangePassword}
                    />
                    <Route
                      path={`/dashboard/bank-details`}
                      component={BankLayout}
                    />
                    <Route
                      path={`/dashboard/new-bank`}
                      component={BankDetails}
                    />
                    <Route
                      exact
                      path={`/dashboard/cart/:facilityId`}
                      component={CartList}
                    />
                    <Route
                      exact
                      path={`/dashboard/wallet`}
                      component={Wallet}
                    />
                    <Route
                      exact
                      path={`/dashboard/wallet/transactions`}
                      render={(props) => (
                        <TransactionHistory {...props} showAll />
                      )}
                    />{" "}
                    <Route
                      exact
                      path={`/dashboard/wallet/subscriptions`}
                      render={(props) => (
                        <ManageSubscriptions {...props} showAll />
                      )}
                    />
                  </>
                )}
                {roleID === "2" && (
                  <>
                    <Route
                      exact
                      path="/dashboard/fees"
                      render={(props) => (
                        <Fees {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/users/wallet"
                      render={(props) => <UserWalletDetails {...props} />}
                    />
                    <Route
                      exact
                      path="/dashboard/users/wallet/:userId"
                      render={(props) => <UserWalletDetails {...props} />}
                    />
                    <Route
                      exact
                      path="/dashboard/users"
                      render={(props) => (
                        <Users {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/suggestion"
                      render={(props) => (
                        <Suggestion {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/facilities"
                      render={(props) => (
                        <Facilities {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      path={`/dashboard/new-facility`}
                      component={NewFacility}
                    />
                    <Route
                      path={`/dashboard/new-doctor`}
                      component={NewDoctor}
                    />
                    <Route
                      path={`/dashboard/services/:facilityId`}
                      component={Services}
                    />
                    <Route
                      exact
                      path={`/dashboard/messages`}
                      component={ChatLayout}
                    />
                    <Route
                      exact
                      path={`/dashboard/bank-details`}
                      render={(props) => (
                        <BankLayout {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      path={`/dashboard/new-bank`}
                      component={BankDetails}
                    />
                    <Route
                      exact
                      path="/dashboard/profile"
                      component={Profile}
                    />
                    <Route
                      path={`/dashboard/change-password`}
                      component={ChangePassword}
                    />
                    <Route
                      exact
                      path="/dashboard/"
                      render={(props) => (
                        <ExploreLayout
                          {...props}
                          cartItems={
                            cartItems?.[0]?.svcsc_cart_jsn
                              ?.service_order_line || []
                          }
                          handleCartItems={handleCart}
                        />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/map"
                      render={(props) => (
                        <MapView
                          {...props}
                          isLogged={true}
                          cartItems={
                            cartItems?.[0]?.svcsc_cart_jsn
                              ?.service_order_line || []
                          }
                          handleCartItems={handleCart}
                        />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/patient"
                      render={(props) => (
                        <Patient {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/order"
                      render={(props) => (
                        <Order {...props} searchQuery={searchQuery} />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/transactions"
                      render={(props) => (
                        <TransactionsWrapper
                          {...props}
                          searchQuery={searchQuery}
                        />
                      )}
                    />
                    <Route path={`/dashboard/new-order`} component={NewOrder} />
                    <Route
                      exact
                      path="/dashboard/addorder/orderlayout"
                      component={OrderLayout}
                    />
                    <Route
                      exact
                      path={`/dashboard/explore/services/:facilityId`}
                      component={ServicesOpen}
                    />
                    <Route
                      exact
                      path={`/dashboard/order/addorder/services/:facilityId`}
                      component={OrderServicesOpen}
                    />
                    <Route
                      path={`/dashboard/explore/:serviceID/patient-profiles`}
                      component={ProfileListexplore}
                    />
                    <Route
                      path={`/dashboard/explore/add-patient`}
                      component={PatientProfileForm}
                    />
                    <Route
                      path={`/dashboard/order/addorder/:serviceID/patient-profiles`}
                      component={ProfileListOrder}
                    />
                    <Route
                      exact
                      path={`/dashboard/payout/`}
                      component={Payout}
                    />
                    <Route
                      exact
                      path={`/dashboard/payoutfiles/`}
                      component={PayoutFiles}
                    />
                    <Route
                      exact
                      path={`/dashboard/cart/:facilityId`}
                      component={CartList}
                    />
                    <Route
                      exact
                      path={`/dashboard/wallet`}
                      component={Wallet}
                    />
                    <Route
                      exact
                      path={`/dashboard/wallet/transactions`}
                      render={(props) => (
                        <TransactionHistory {...props} showAll />
                      )}
                    />{" "}
                    <Route
                      exact
                      path={`/dashboard/wallet/subscriptions`}
                      render={(props) => (
                        <ManageSubscriptions {...props} showAll />
                      )}
                    />
                    <Route
                      exact
                      path="/dashboard/mainDashboard"
                      component={MainDashboard}
                    />
                  </>
                )}
              </Col>
            </Row>
            <LogoutModal show={show} handleClose={handleClose} />
          </Container>
        </div>
      </div>
    </Layout>
  );
};
export default withRouter(DashboardLayout);
